export default __webpack_public_path__ + "static/stacked-bar-e4c8c77e2fa0b22a1967394e000490de.png";